import CURRENCIES from '@stripe-internal/currencies';

export const DEFAULT_DECIMAL_LENGTH = 2;

const log10 = (n: number): number => Math.log(n) / Math.LN10;

export default function currencyToDecimalLength(
  currency?: string | null,
  defaultLength = DEFAULT_DECIMAL_LENGTH,
): number {
  const currencyData = CURRENCIES[currency || ''];

  if (currencyData?.subunit_to_unit) {
    return Math.round(log10(currencyData.subunit_to_unit));
  }

  return defaultLength;
}
